import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const saveQuoteRequest = async (description: string, category: string, timeframe: string) => {
  try {
    const { data, error } = await supabase
      .from('quote_requests')
      .insert([{ description, category, timeframe }])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error saving quote request:', error);
    return null;
  }
};

export const saveQuoteEstimate = async (
  quoteRequestId: string,
  minPrice: number,
  maxPrice: number,
  confidence: string
) => {
  try {
    const { data, error } = await supabase
      .from('quote_estimates')
      .insert([{
        quote_request_id: quoteRequestId,
        min_price: minPrice,
        max_price: maxPrice,
        confidence
      }])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error saving quote estimate:', error);
    return null;
  }
};

export const saveClarifyingQuestions = async (
  quoteRequestId: string,
  questions: Array<{
    question: string;
    type: string;
    options?: string[];
    answer?: string | boolean;
  }>
) => {
  try {
    const { data, error } = await supabase
      .from('quote_clarifying_questions')
      .insert(
        questions.map(q => ({
          quote_request_id: quoteRequestId,
          question: q.question,
          question_type: q.type,
          options: q.options,
          answer: q.answer?.toString()
        }))
      )
      .select();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error saving clarifying questions:', error);
    return null;
  }
};

export const saveQuoteContact = async (
  quoteRequestId: string,
  contactInfo: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    address: string;
    city: string;
    zipCode: string;
    preferredContact: string;
    numberOfQuotes: string;
    previousVendors: string;
  }
) => {
  try {
    const { data, error } = await supabase
      .from('quote_contacts')
      .insert([{
        quote_request_id: quoteRequestId,
        first_name: contactInfo.firstName,
        last_name: contactInfo.lastName,
        email: contactInfo.email,
        phone: contactInfo.phone,
        address: contactInfo.address,
        city: contactInfo.city,
        zip_code: contactInfo.zipCode,
        preferred_contact: contactInfo.preferredContact,
        number_of_quotes: contactInfo.numberOfQuotes,
        previous_vendors: contactInfo.previousVendors
      }])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error saving quote contact:', error);
    return null;
  }
};